'use strict';

var buildRelativeAliases = require('../internal/buildRelativeAliases');

buildRelativeAliases();